import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import dayjs from 'dayjs'
import { getQuery } from '@vt/utils'
import { useParams } from 'react-router-dom'
import { find, pick } from 'lodash-es'
import { buildQueries } from '@vt/apis/lib-ex/utils/transformers'
import { useTitle, AppProvider, useProjectStore } from '@vt/hooks'
import { setScale } from '@ow/utils'
import { OSSURL } from '../constant'
import Item from './item'
import Map from './map'

import { fetchcConfigData } from '../apis'

const Title = styled.div`
  background: url(${OSSURL}/title_bg.png) no-repeat;
  background-size: 100% 100%;
  height: 90px;
  color: #fff;
  z-index: 100;
  ${tw`w-full relative px-5 pt-3`}
  .title {
    background-image: linear-gradient(to bottom, #fff 20%, #3597e8 85%);
    background-clip: text;
    color: transparent;
    font-family: YouSheBiaoTiHei;
    font-size: 38px;
    ${tw`pb-3.5 text-center`}
  }
  .side {
    top: 20px;
    ${tw`pb-7 absolute`}
  }
`

const Button = styled.div`
  width: 64px;
  height: 40px;
  border: 1px solid #389ef2;
  border-radius: 4px 0 0 4px;
  background-image: ${(props) => {
    return props.active
      ? 'linear-gradient(0deg, rgba(0,97,178,0.70) 0%, rgba(65,134,245,0.70) 100%)'
      : ''
  }};
  ${tw`flex items-center justify-center cursor-pointer`}
`

const Index = function () {
  const [configData, setConfigData] = useState([])
  const [timeDsl, setTimeDsl] = useState()
  const [title, setTitle] = useState('')
  const [currentTime, setCurrentTime] = useState('all')
  const { tpl } = getQuery()
  const { appId } = useParams()
  useTitle(title)

  const { warpperRef } = useProjectStore((state) => pick(state, ['warpperRef']))

  warpperRef.current.style.width = '1920px'
  warpperRef.current.style.height = '1080px'

  useEffect(() => {
    fetchcConfigData(appId, tpl).then((res) => {
      console.log('config', res)
      setConfigData(res.value.data || [])
      setTitle(res.value.title)
    })
    setScale(1920, 1080, '#010914')
  }, [])

  const changeTime = (time) => {
    setCurrentTime(time)
    let value = null
    if (time !== 'all') {
      value = {
        startDate: new Date(dayjs().startOf(time)),
        endDate: new Date(dayjs().endOf(time)),
      }
    }
    const queries = {
      filters: {
        logicType: 'and',
        queries: [
          {
            slug: 'createdAt',
            value,
            queryType: ['dayRange'],
          },
        ],
      },
    }
    if (value === null) {
      setTimeDsl(null)
    } else {
      const dsl = buildQueries(queries)
      setTimeDsl(dsl)
    }
  }

  return (
    <div className="w-full h-full text-white flex flex-col items-start">
      <div className="w-full h-full absolute left-0 top-0">
        {configData.length && (
          <Map data={find(configData, ['type', 'map'])} customDsl={timeDsl} />
        )}
      </div>
      <Title>
        <div className="side">{dayjs().format('YYYY-MM-DD')}</div>
        <div className="title">{title}</div>
      </Title>
      <div
        className="flex items-center absolute"
        style={{ top: '100px', left: '53%' }}
      >
        <Button
          active={currentTime === 'all'}
          onClick={() => {
            changeTime('all')
          }}
        >
          全部
        </Button>
        <Button
          active={currentTime === 'day'}
          onClick={() => {
            changeTime('day')
          }}
        >
          今日
        </Button>
        <Button
          active={currentTime === 'week'}
          onClick={() => {
            changeTime('week')
          }}
        >
          本周
        </Button>
        <Button
          active={currentTime === 'month'}
          onClick={() => {
            changeTime('month')
          }}
        >
          本月
        </Button>
        <Button
          active={currentTime === 'quarter'}
          onClick={() => {
            changeTime('quarter')
          }}
        >
          本季度
        </Button>
        <Button
          active={currentTime === 'year'}
          onClick={() => {
            changeTime('year')
          }}
        >
          本年
        </Button>
      </div>
      <div
        className="flex w-full flex-1 items-start justify-between px-4 pb-4 pointer-events-none"
        style={{ zIndex: 100 }}
      >
        <Item
          configData={configData.slice(
            0,
            Math.ceil(
              configData.filter((config) => config.type !== 'map').length / 2
            )
          )}
          time={timeDsl}
        />
        <Item
          configData={configData
            .filter((config) => config.type !== 'map')
            .slice(
              Math.ceil(
                configData.filter((config) => config.type !== 'map').length / 2
              ),
              6
            )}
          time={timeDsl}
        />
      </div>
    </div>
  )
}

const Screen = function () {
  const { appId } = useParams()
  const { tpl } = getQuery()
  return (
    <AppProvider appId={appId} tpl={tpl}>
      <Index />
    </AppProvider>
  )
}
export default Screen
